import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { AppRoutes } from "navigations/app-routes";
import _ from "lodash";
import { stackProps } from "utils/helper-navigation";
import HelperString from "utils/helper-string";
import { createPageTitle } from 'utils/helper-page-title'
import ManagementCompaniesScene from 'scenes/management/company/companies'
import ManagementCompanyScene from 'scenes/management/company/company'
import ManagementDepartmentScene from 'scenes/management/company/department'

const Stack = createNativeStackNavigator();

const screens = {
	[AppRoutes.MANAGEMENT_COMPANY_COMPANIES_INDEX]: {
		component: ManagementCompaniesScene,
	},
	[AppRoutes.MANAGEMENT_COMPANY_COMPANIES_VIEW]: {
		component: ManagementCompanyScene,
	},
	[AppRoutes.MANAGEMENT_COMPANY_COMPANIES_DEPARTMENT]: {
		component: ManagementDepartmentScene,
	}
}

const ManagementCompanyNavigator = ( props ) => {
	return (
		<Stack.Navigator
			{ ...stackProps }>

			{ _.map( screens, ( screen, name ) => {
				return (
					<Stack.Screen
						key={ HelperString.hash( `ManagementCompanyNavigator`, name ) }
						name={ name }
						options={{
							title: createPageTitle( _.get( screen, 'title', null ) )
						}}
						component={ screen.component }
					/>
				);
			})}
		</Stack.Navigator>
	);
};

export default ManagementCompanyNavigator
